module Meevo.Plugins.SmartCenter {
    import ClientTypeEnum = Meevo.Model.ClientTypeEnum;
    import EmployeeCategory = Meevo.Model.EmployeeCategory;

    const TILES_MAP_FUNCTIONS = {
        RetailUnitsSales: (filterCriteria: { employeeCategory: EmployeeCategory }) => {
            return !filterCriteria.employeeCategory ? {} : {
                employeeCategoryId: filterCriteria.employeeCategory.id
            }
        },
        AppointmentsToReschedule: (filterCriteria: { selectedValue: string }) => {
            if (!filterCriteria.selectedValue) {
                filterCriteria.selectedValue = "2";
            }
            return {
                displayEmployeeNotScheduledOnly: (filterCriteria.selectedValue == "1"),
                displayRescheduleRequestOnly: (filterCriteria.selectedValue == "2")  //default to this filter on first load
            }
        },
    };


    class SmartCenterTileExtendedInfoController {

        private parameters: any;
        private results: Array<any>;
        private ClientDisplayName: string;
        private EmployeeDisplayName: string;
        private fullTemplateUrl: string;
        private filterTemplateUrl: string;
        private headerTemplateUrl: string;
        private footerTemplateUrl: string;
        private smartTileName: string;
        private smartCenterBusinessTypeId: string;
        private smartCenterHomeLocationId: number;
        private filterCriteria: Object;
        private tileHasFilter: boolean;
        private tileHasFooter: boolean;
        private currentTime: Date;

        private response: any;
        private responseFooter: any;

        static $inject = [
            'meevo.plugins.smartCenter.SmartCenterService',
            '$mdDialog',
            '$translate',
            'meevo.components.common.IdentityService',
            'tileId',
            'id',
            'title',
            'templateKey',
            'meevo.components.common.DataService',
            'meevo.components.common.ClientMembershipDataService',
            '$rootScope',
            'tile',
            "meevoDateFilterFilter"
        ];

        get showDefaultTemplate(): boolean {
            return this.smartTileName !== 'FiveStarRating';
        }

        get showFooter(): boolean {
            switch (this.smartTileName) {
                case 'ServiceCategorySales':
                case 'ProductCategorySales':
                case 'EstimatedSales':
                case 'NetSales':
                    return true;
            }
            return false;
        }

        constructor(private smartCenterService: SmartCenterService,
            private $mdDialog: angular.material.IDialogService,
            private $translate: angular.translate.ITranslateService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private tileId: any,
            private id: any,
            private title: string,
            private templateKey: string,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private membershipService: Meevo.Components.Common.ClientMembershipDataService,
            private $rootScope: ng.IRootScopeService,
            private tile: any,
            protected meevoDateFilter: any) {
            // TODO: Review if we want full template URL stored in DB or how this should actually be built

            tile.parsedParameters = JSON.parse(tile.parameter);

            if (this.showDefaultTemplate && templateKey) {
                this.filterCriteria = {};
                this.tileHasFilter = typeof TILES_MAP_FUNCTIONS[this.smartTileName] === 'function';
                this.tileHasFooter = this.showFooter;

                const baseUrl = 'app/plugins/smartCenter/extendedTileTemplates/';
                this.headerTemplateUrl = `${baseUrl}${templateKey}Header.html`;
                this.fullTemplateUrl = `${baseUrl}${templateKey}.html`;
                this.footerTemplateUrl = `${baseUrl}${templateKey}Footer.html`;
                this.filterTemplateUrl = `${baseUrl}${templateKey}Filter.html`;

                this.getExtendedInfoPage().then(() => {
                    if (this.tileHasFooter) {
                        this.getExtendedInfoFooter();
                    }
                });

                this.currentTime = new Date();
            }
        }

        getExtendedInfoPage() {
            this.response = new Meevo.Components.BaseClasses.PagedResults(this.dataService, 'SmartTile/' + this.tileId);

            // TODO: Where did this come from!? Any filtering concerns should be handled on the server and extract any
            // necessary parameters from the tile parameters server side. It looks like this only was done for one tile (RetailUnitSales?)
            // but should really not be handled this way.
            //filter criteria for AppointmentToReschedule comes from user input at time of popup detail access
            const filterCriteria = !this.tileHasFilter ? {} : TILES_MAP_FUNCTIONS[this.smartTileName](this.filterCriteria);
            let request = {
                // NOTE: PagedResults need paging properties on the request
                pageNumber: 0,
                itemsPerPage: 200,
                criteria: {
                    // NOTE: On the server internal criteria is built to the proc call, so paging information is necessary
                    pageNumber: 0,
                    itemsPerPage: 200,
                    // TODO: Need requirements on all tile detail data sorting to finalize sort support
                    //sortDirection: Model.SortDirection.Ascending,
                    smartCenterBusinessTypeId: this.smartCenterBusinessTypeId,
                    smartCenterLocationId: this.smartCenterHomeLocationId,
                    filterCriteria
                }
            };

            return this.response.initSearch(request);
        }

        getExtendedInfoFooter() {
            this.responseFooter = new Meevo.Components.BaseClasses.PagedResults(this.dataService, 'SmartTile/' + this.tileId);

            let filterCriteria = !this.tileHasFilter ? {} : TILES_MAP_FUNCTIONS[this.smartTileName](this.filterCriteria);
            let requestFooter = {
                pageNumber: 0,
                itemsPerPage: 25,
                criteria: {
                    pageNumber: 0,
                    itemsPerPage: 25,
                    isFooter: true,
                    smartCenterBusinessTypeId: this.smartCenterBusinessTypeId,
                    smartCenterLocationId: this.smartCenterHomeLocationId,
                    filterCriteria
                }
            };

            return this.responseFooter.initSearch(requestFooter);
        }

        getExtendedInfo() {
            this.smartCenterService.getTileExtendedData(this.tileId).then(result => {
                this.results = result;
            });
        }

        cancel() {
            this.$mdDialog.cancel();
        }

        getClientDisplayName(item: any) {
            if (!item) {
                return '';
            }

            let clientDisplayName = item.ClientDisplayName;

            switch (item.ClientTypeEnum) {
                case Model.ClientTypeEnum.AnonymousMale:
                    clientDisplayName = this.$translate.instant('LABEL_ANONYMOUS_MALE');
                    break;
                case Model.ClientTypeEnum.AnonymousFemale:
                    clientDisplayName = this.$translate.instant('LABEL_ANONYMOUS_FEMALE');
                    break;
                case Model.ClientTypeEnum.AnonymousOther:
                    clientDisplayName = this.$translate.instant('LABEL_ANONYMOUS_FEMALE');
                    break;
            }

            this.ClientDisplayName = clientDisplayName;

            return clientDisplayName;
        }

        getEmployeeDisplayName(item: any) {
            if (Model.Guard.isNothing(item)) {
                return '';
            }

            switch (this.templateKey) {
                case 'employeebirthdayanniversary':
                    this.EmployeeDisplayName = `${item.EmployeeCode}: ${item.LastName}, ${item.FirstName}`;
                    break;
                case 'client':
                case 'appointmentreschedule':
                case 'noshowappointments':
                    this.EmployeeDisplayName = item.EmployeeDisplayName;
                    break;
            }

            return this.EmployeeDisplayName;
        }
        getConcatenatedServiceDisplayName(shortCut: string, serviceName: string) {

            return `${shortCut} : ${serviceName}`;
        }

        selectClient(clientId: string, clientDisplayName: string) {
            if (clientId === null) {
                return;
            }
            this.$mdDialog.hide().then(() => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: 'client',
                    stateParams: {
                        actionState: Meevo.Model.MaintenanceFormState.Readonly,
                        targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                        callback: null,
                        callbackState: null,
                        id: clientId,
                        initialEditSection: 'SECTION_MAIN',
                        clientDisplayName: clientDisplayName
                    }
                });
            });
        }

        getMembershipStatusIcon(item: any) {
            return this.membershipService.getClientMembershipIndicatorEnumIcon(item.ClientMembershipIndicatorEnum);
        }

        getMembershipStatusText(item: any) {
            return this.membershipService.getClientMembershipIndicatorStatusEnumText(item.ClientMembershipIndicatorStatus);
        }

        getLicenseInsuranceDisplay(item: any) {
            if (Model.Guard.isNothing(item))
                return '';
            let key = item.EmployeeLicenseEnum === Meevo.Model.EmployeeLicenseEnum.Insurance ? 'LABEL_INSURANCE' : 'LABEL_LICENSE';
            return this.$translate.instant(key);
        }

        isApplicationInCoMode(): boolean {
            return this.identityService.inCentralOfficeMode();
        }

        getTileParameters(): boolean {
            return this.tile.parsedParameters;
        }

        loadStandingAppointments = (item: any) => {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: 'standingAppointments',
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Editing,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    id: item.AppointmentScheduleId,
                    initialEditSection: "LABEL_MANAGE_APPOINTMENTS"
                }
            });
            this.$mdDialog.cancel();
        }

        sendToClient = (item: any) => {
            if (!item.ClientId) {
                return;
            }

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: 'client',
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    id: item.ClientId
                }
            });
            this.$mdDialog.cancel();
        }

        sendToMembershipManager = (item: any) => {
            if (!item.ClientMembershipId) {
                return;
            }

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: 'membershipManager',
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    id: item.ClientMembershipId
                }
            });
            this.$mdDialog.cancel();
        }

        getStatus(item) {
            let ret: any = { text: '' };

            let itemDate = moment(item.AppointmentDate).startOf("day");
            let date = moment().startOf("day");

            if (itemDate.isBefore(date)) {
                if (item.FinalState == Meevo.Model.AppointFinalStateEnum.CheckedOut) {
                    ret.text = this.$translate.instant("LABEL_CHECKED_OUT");
                    ret.class = "status-checked-out";
                }
                else if (item.TransitionState == Meevo.Model.AppointStateEnum.NoShow) {
                    ret.text = this.$translate.instant("LABEL_NO_SHOW");
                    ret.class = "status-no-show";
                } else {
                    ret.text = this.$translate.instant("LABEL_NOT_CHECKED_OUT");
                    ret.class = "status-not-checked-out";
                }
            }
            else if (itemDate.isSame(date)) {
                if (item.FinalState == Meevo.Model.AppointFinalStateEnum.CheckedOut) {
                    ret.text = this.$translate.instant("LABEL_CHECKED_OUT");
                    ret.class = "status-checked-out";
                }
                else if (item.TransitionState == Meevo.Model.AppointStateEnum.NoShow) {
                    ret.text = this.$translate.instant("LABEL_NO_SHOW");
                    ret.class = "status-no-show";
                } else if (item.TransitionState == Meevo.Model.AppointStateEnum.RunningLate) {
                    ret.text = this.$translate.instant("LABEL_RUNNING_LATE");
                    ret.class = "status-running-late";
                } else if (item.TransitionState == Meevo.Model.AppointStateEnum.CheckedIn) {
                    ret.text = this.$translate.instant("LABEL_CHECKED_IN");
                    ret.class = "status-checked-in";
                } else if (item.TransitionState == Meevo.Model.AppointStateEnum.Booked) {
                    if (moment(item.AppointmentDate) >= moment()) {
                        ret.text = this.$translate.instant("LABEL_NOT_DUE_IN");
                        ret.class = "status-not-due-in";
                    } else {
                        ret.text = this.$translate.instant("LABEL_LATE");
                        ret.class = "status-late";
                    }
                }
            }
            else {
                ret.text = this.$translate.instant("LABEL_FUTURE_APPOINTMENT");
                ret.class = "status-future";
            }
            return ret;
        }

        getTileAppointmentCountStatus(item) {
            let status = '';
            if (item.FinalState == Model.AppointFinalStateEnum.Cancelled) {
                status = `${item.FinalStateDisplayName} ${this.meevoDateFilter(item.DateUpdated)}`
                if (item.CancellationTypeDisplayName) {
                    status = `${status} ${this.$translate.instant("LABEL_REASON")}: ${item.CancellationTypeDisplayName}`;
                }
            }
            else {
                status = item.TransitionStateDisplayName;
            }
            return status;
        }

        isMultiDate() {
            if (this.parameters.dateRangeParam) {
                return this.parameters.dateRangeParam.parameterValue != Model.TimePeriodEnum[Model.TimePeriodEnum.Today] &&
                    this.parameters.dateRangeParam.parameterValue != Model.TimePeriodEnum[Model.TimePeriodEnum.Tomorrow] &&
                    this.parameters.dateRangeParam.parameterValue != Model.TimePeriodEnum[Model.TimePeriodEnum.Yesterday];
            }
            return true;
        }

        sendToStanding(item) {
            if (item.TransitionState == Model.AppointStateEnum.StandingConflict && item.ScheduleId) {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: 'standingAppointments',
                    stateParams: {
                        actionState: Meevo.Model.MaintenanceFormState.Readonly,
                        targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                        id: item.ScheduleId,
                        initialEditSection: "LABEL_MANAGE_APPOINTMENTS"
                    }
                });
                this.$mdDialog.cancel();
            }
        }
        getRescheduleStatus(item) {
            let status = "";

            if (item.IsRescheduled) {
                status += `${this.$translate.instant("LABEL_RESCHEDULED")}, `;
            }

            if (item.IsNotBusinessHours) {
                status += `${this.$translate.instant("LABEL_MEEVO_MESSENGER_OUTSIDE_HOURS")}, `;
            }
            else if (item.IsNotScheduled) {
                status += `${this.$translate.instant("LABEL_NOT_SCHEDULED")}, `;
            }

            if (item.IsDoubleBooked) {
                status += `${this.$translate.instant("LABEL_DOUBLE_BOOKED")}, `;
            }

            if (status.length >= 2) {
                status = status.substr(0, status.length - 2);
            }
            return status;
        }

        getConfirmationStatus(item) {
            let status = '';
            switch (item.ConfirmState) {
                case Meevo.Model.AppointConfirmStateEnum.AwaitingResponse:
                    status = this.$translate.instant("LABEL_AWAITING_RESPONSE");
                    break;
                case Meevo.Model.AppointConfirmStateEnum.Confirmed:
                    status = this.$translate.instant("LABEL_CONFIRMED");
                    break;
                case Meevo.Model.AppointConfirmStateEnum.DoNotConfirm:
                    status = this.$translate.instant("LABEL_DO_NOT_CONFIRM");
                    break;
                case Meevo.Model.AppointConfirmStateEnum.LeftMessage:
                    status = this.$translate.instant("LABEL_LEFT_MESSAGE");
                    break;
                case Meevo.Model.AppointConfirmStateEnum.Queued:
                    status = this.$translate.instant("LABEL_QUEUED");
                    break;
                case Meevo.Model.AppointConfirmStateEnum.RespondedReschedule:
                    status = this.$translate.instant("LABEL_REQUESTED_RESCHEDULE");
                    break;
                case Meevo.Model.AppointConfirmStateEnum.Unconfirmed:
                    status = this.$translate.instant("LABEL_UNCONFIRMED");
                    break;
                case Meevo.Model.AppointConfirmStateEnum.UnableToContact:
                    status = this.$translate.instant("LABEL_UNABLE_TO_CONTACT");
                    break;
            }

            if (item.ConfirmState == Meevo.Model.ConfirmStateEnum.Confirmed) {
                status = `${status} on ${this.meevoDateFilter(item.ConfirmedDate)}`;
                if (item.CommunicationMethodDisplayName) {
                    status = `${status} via ${item.CommunicationMethodDisplayName}`;
                }
            }
            return status;
        }
    }

    angular.module('meevo.plugins.smartCenter')
        .controller('meevo.plugins.smartCenter.SmartCenterTileExtendedInfoController', SmartCenterTileExtendedInfoController);
}
